import { DoubleConfirm } from "@/models/api/DoubleConfirm";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { SettlementData } from "@/models/api/settlements/SettlementData";
import { UnsettledDocumentItem } from "@/models/api/settlements/UsettledDocumentItem";
import { VATMarginDocumentResponse } from "@/models/api/settlements/VATMarginDocument";
import CancellableHelper from "@/requests/CancellableHelper";

//#region Routes
export const URL_GET_VAT_MARGIN_DOCUMENTS = "/Settlement/VATMargin";
export const URL_POST_SEND_SETTLEMENT = "/Settlement/Send/${DocumentId}";
export const URL_GET_UNSETTLED_DOCUMENT_ITEMS = "/Settlement/Unsettled/${DocumentId}";
export const URL_POST_SETTLE_DOCUMENT_ITEMS = "/Settlement/Settle/${DocumentId}";
export const URL_GET_SETTLEMENT_DOCUMENT_DATA = "/Settlement/Data/${DocumentId}";

export const URL_POST_DELETE_VAT_MARGIN_SETTLEMENT = "/Settlement/Delete/${DocumentId}";
export const URL_POST_DELETE_PAIR_COST_DOCUMENT_IN_VAT_MARGIN_SETTLEMENT =
  "/Settlement/Delete/${DocumentId}/PairCostDocuments";

export const URL_POST_CHANGE_PURCHASE_PRICE = "/Settlement/DocumentItem/${DocumentItemId}/EditPurchasePrice";
export const URL_POST_GENERATE_VIRTUAL_SALE_DOCUMENT = "/Settlement/Document/${DocumentId}/GenerateVirtual";
export const URL_POST_ADD_TO_DOCUMENT_NEGATIVE_COST_DOCUMENT_PAIR =
  "/Settlement/Document/${DocumentId}/AddNegativeCostDocumentPair";
export const URL_POST_ADD_TO_DOCUMENT_POSITIVE_COST_DOCUMENT_PAIR =
  "/Settlement/Document/${DocumentId}/AddPositiveCostDocumentPair";
//#endregion

const _getVATMarginDocuments = new CancellableHelper<VATMarginDocumentResponse>(
  URL_GET_VAT_MARGIN_DOCUMENTS,
  VATMarginDocumentResponse
);
_getVATMarginDocuments.jsonSerializer = true;
export const getVATMarginDocuments = async (
  genericTableRequest: GenericTableRequest
): Promise<VATMarginDocumentResponse> => {
  return await _getVATMarginDocuments.get(genericTableRequest);
};

const _postSendSettlement = new CancellableHelper<null>(URL_POST_SEND_SETTLEMENT, null, true);
export const postSendSettlement = async (documentId: string): Promise<null> => {
  return await _postSendSettlement.post({ DocumentId: documentId }, null);
};

const _getUnsettledDocumentItems = new CancellableHelper<Array<UnsettledDocumentItem>>(
  URL_GET_UNSETTLED_DOCUMENT_ITEMS,
  UnsettledDocumentItem
);
export const getUnsettledDocumentItems = async (documentId: string): Promise<Array<UnsettledDocumentItem>> => {
  return await _getUnsettledDocumentItems.get({ DocumentId: documentId });
};

const _postSettleDocumentItems = new CancellableHelper<null>(URL_POST_SETTLE_DOCUMENT_ITEMS, null, true);
export const postSettleDocumentItems = async (documentId: string): Promise<null> => {
  return await _postSettleDocumentItems.post({ DocumentId: documentId }, null);
};

const _getSettlementDocumentData = new CancellableHelper<Array<SettlementData>>(
  URL_GET_SETTLEMENT_DOCUMENT_DATA,
  SettlementData
);
export const getSettlementDocumentData = async (documentId: string): Promise<Array<SettlementData>> => {
  return await _getSettlementDocumentData.get({ DocumentId: documentId });
};

const _deleteDocument = new CancellableHelper<DoubleConfirm>(URL_POST_DELETE_VAT_MARGIN_SETTLEMENT);
export const deleteDocument = async (documentId: string, confirmed: boolean) => {
  return _deleteDocument.post({ DocumentId: documentId, Confirmed: confirmed });
};

const _deletePairCostDocument = new CancellableHelper<DoubleConfirm>(
  URL_POST_DELETE_PAIR_COST_DOCUMENT_IN_VAT_MARGIN_SETTLEMENT
);
export const deletePairCostDocument = async (documentId: string, confirmed: boolean) => {
  return _deletePairCostDocument.post({ DocumentId: documentId, Confirmed: confirmed });
};

const _changePurchasePrice = new CancellableHelper<null>(URL_POST_CHANGE_PURCHASE_PRICE, null, true);
export const changePurchasePrice = async (documentItemId: string, purchasePrice: number): Promise<null> => {
  return await _changePurchasePrice.post({ DocumentItemId: documentItemId }, { PurchasePrice: purchasePrice });
};

const _generateVirtualSaleDocument = new CancellableHelper<null>(URL_POST_GENERATE_VIRTUAL_SALE_DOCUMENT, null, true);
export const generateVirtualSaleDocument = async (documentId: string): Promise<null> => {
  return await _generateVirtualSaleDocument.post({ DocumentId: documentId });
};

const _addToDocumentNegativeCostDocumentPair = new CancellableHelper<null>(
  URL_POST_ADD_TO_DOCUMENT_NEGATIVE_COST_DOCUMENT_PAIR,
  null,
  true
);
export const addToDocumentNegativeCostDocumentPair = async (documentId: string): Promise<null> => {
  return await _addToDocumentNegativeCostDocumentPair.post({ DocumentId: documentId });
};

const _addToDocumentPositiveCostDocumentPair = new CancellableHelper<null>(
  URL_POST_ADD_TO_DOCUMENT_POSITIVE_COST_DOCUMENT_PAIR,
  null,
  true
);
export const addToDocumentPositiveCostDocumentPair = async (documentId: string): Promise<null> => {
  return await _addToDocumentPositiveCostDocumentPair.post({ DocumentId: documentId });
};
